import React, { useState } from "react"
import PropTypes from "prop-types"
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap"
import "./CaseCreationCard.scss"

const CaseCreationCard = (props) => {
  const [patientPositiveTabOpen, setPatientPositiveTab] = useState(
    props.patientPositiveTab
  )

  return (
    <div className="CaseCreationCard">
      <div className="case-display">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={patientPositiveTabOpen ? "" : "active"}
              onClick={() => setPatientPositiveTab(false)}
              id="employeePositiveTab"
            >
              EMPLOYEE POSITIVE
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={patientPositiveTabOpen ? "active" : ""}
              onClick={() => setPatientPositiveTab(true)}
              id="patientPositiveTab"
            >
              PATIENT POSITIVE
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent
          activeTab={
            patientPositiveTabOpen
              ? "patientPositiveCase"
              : "employeePositiveCase"
          }
        >
          <TabPane tabId="patientPositiveCase">
            {patientPositiveTabOpen &&
              props.creationComponent &&
              React.createElement(props.creationComponent, {
                onSuccess: props.onSuccess,
                submitText: "Open Case",
                caseType: "patientPositive",
              })}
          </TabPane>
          <TabPane tabId="employeePositiveCase">
            {!patientPositiveTabOpen &&
              props.creationComponent &&
              React.createElement(props.creationComponent, {
                onSuccess: props.onSuccess,
                submitText: "Open Case",
                caseType: "employeePositive",
              })}
          </TabPane>
        </TabContent>
      </div>
    </div>
  )
}

CaseCreationCard.propTypes = {
  creationComponent: PropTypes.elementType,
  patientPositiveTab: PropTypes.bool,
  onSuccess: PropTypes.func,
}

CaseCreationCard.defaultProps = {
  patientPositiveTab: false,
}

export default CaseCreationCard
